import React from "react";
import { Link } from "react-router-dom";
import "./ContactPage.css";

function ContactSection() {
  return (
    <div className="contact-container">

      {/* Top Title Section */}
      <div className="title-section">
        <p className="small-text">CONTACT US FOR</p>
        <h1>
          Instrumentation,Control valves & Automation <span>Solution Provider</span>
        </h1>
        <Link to="/" className="text-danger text-decoration-none">Home</Link>
            <span>/</span>
            <span>About Us</span>
      </div>

      {/* Banner and Address Card */}
      <div className="banner-section">

        <div className="address-card">
          <p className="label">CORPORATE OFFICE</p>
          <p className="value">
           CIRA Technology Pvt Ltd  <br />
            Chrompet,Chennai – 600064 <br />
          </p>
          <p className="label">REGIONAL OFFICE</p>
          <p className="value">
           CIRA Technology Pvt Ltd  <br />
            Thindal, Erode – 638012
          </p>

          <p className="label">CALL US</p>
          <p className="value">+91 98400 98717</p>

          <p className="label">EMAIL US</p>
          <p className="value">Sriarun@ciratechnology.com</p>
{/* 
          <div className="social">
            <i className="fa-brands fa-facebook"></i>
            <i className="fa-brands fa-twitter"></i>
            <i className="fa-brands fa-linkedin"></i>
          </div> */}
        </div>

        <div className="banner-image"></div>

      </div>

      {/* Form + Map */}
      <div className="form-map-section">

        {/* Form */}
        <div className="left-form">
          <p className="form-small">ENQUIRE NOW</p>
          <form>
            <input type="text" placeholder="NAME" />
            <input type="email" placeholder="EMAIL ADDRESS" />
            <input type="text" placeholder="PHONE NUMBER" />
             <input type="text" placeholder="COMPANYA NAME" />
            <textarea placeholder="MESSAGE"></textarea>

            <button type="submit">SUBMIT</button>
          </form>
        </div>

        {/* Map */}
        <div className="right-map">

          

          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.4920244241325!2d80.14449021499644!3d12.940336890876383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525f962f2c5b85%3A0xaa99d4baea5080ba!2sCIRA%20Technology%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1621114505759!5m2!1sen!2sin"
            loading="lazy"
          ></iframe>
        </div>

      </div>
    </div>
  );
}

export default ContactSection;
